module.exports = __webpack_public_path__ + "static/media/hamnoy-norway.4797a69a.jpg";